(function(){
    'use strict';
    var __env = {};
    if(window){
        Object.assign(__env,window.__env);
    }
    angular
        .module('dspApp')
        .constant('ENV',__env)
})();